import { takeLatest } from 'redux-saga/effects';
import sagaActions from '../../actions/index';
import { randomImageSaga, setRandomImageSaga } from './randomImageSaga';

export function* randomSaga() {
  yield takeLatest(sagaActions.GET_RANDOM_IMAGE, randomImageSaga);
  yield takeLatest(sagaActions.EDIT_RANDOM_IMAGE, setRandomImageSaga);
}
